import React, {useState} from "react"
import MainHeader from "../../mainComponents/Header";
import MainFooter from "mainComponents/MainFooter";
import {Heading} from "../../components";
import {useTranslation} from "react-i18next";
import MainHeaderWithBurger from "../../components/HeaderButton/headerWithBurgerMain";

export default function AboutUsPage() {
    const {t} = useTranslation();

    const tabs = [
        {
            id: 'aboutUs',
            title: t("aboutUs.tabs.1.tabsName"),
            tabsTitle: t("aboutUs.tabs.1.tabsTitle"),
            content: () =>
                <>
                    <div>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("aboutUs.tabs.1.tabsDescription1")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5] mt-2`}>
                            {t("aboutUs.tabs.1.tabsDescription2")}
                        </Heading>
                    </div>
                    <img
                        src={"/images/aboutUSPage_1.png" }
                        alt={"Page Logo"}
                        className={"object-contain relative mt-5 rounded-[24px]"}/>
                </>,
        },
        {
            id: 'Priority',
            title: t("aboutUs.tabs.2.tabsName"),
            tabsTitle: t("aboutUs.tabs.2.tabsTitle"),
            content: () =>
                <>
                    <div>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("aboutUs.tabs.2.tabsDescription1")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5] mt-2`}>
                            {t("aboutUs.tabs.2.tabsDescription2")}
                        </Heading>
                    </div>
                    <img
                        src={"/images/aboutUSPage_2.png"}
                        alt={"Page Logo"}
                        className={"object-contain relative mt-5 rounded-[24px]"}/>
                </>,
        }
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    return (
        <div className={"bg-[#B0B0B0] min-h-screen flex flex-col"}>
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>

            <div className={"lg:pb-[160px] md:pb-[100px] sm:pb-[80px] lg:pt-[100px] md:pt-[50px] sm:pt-[80px] lg:px-6 md:px-5 sm:px-4 container-xs"}>

                <div className="flex flex-row md:flex-col sm:flex-col justify-between gap-5 md:gap-[30px] sm:gap-8">

                    {/* Левая часть с табами */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading size={"desktop_heading_2"} className="text-[#191C30E5] whitespace-pre-wrap sm:text-[28px] sm:leading-[120%] sm:uppercase">
                            {t("aboutUs.rightTitle")}
                        </Heading>
                        <ul className="mt-10 md:flex md:flex-wrap md:gap-2 sm:flex sm:flex-wrap sm:gap-1.5">
                            {tabs.map(tab => (
                                <li key={tab.id}
                                    className={" md:max-w-none sm:max-w-none"}>
                                    <button
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`text-left text-[15px] leading-6 px-3 py-[10px] rounded-md transition-colors duration-200 outline-none ${
                                            activeTab === tab.id
                                                ? "bg-white shadow text-black border border-[#FFB800]"
                                                : "text-gray-700 hover:bg-gray-200 border border-transparent"
                                        }`}
                                    >
                                        {tab.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Правая часть с контентом */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading
                            size={"desktop_heading_5"}
                            className="text-[#191C30E5] uppercase whitespace-pre-line">
                            {tabs.find(tab => tab.id === activeTab)?.tabsTitle}
                        </Heading>
                        <div className="mt-4">
                            {tabs.find(tab => tab.id === activeTab)?.content()}
                        </div>
                    </div>

                </div>

            </div>
            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>

    );
}